import PriceChangesFilters from './PriceChangeFilters.container';

export default PriceChangesFilters;



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/PriceChanges/PriceChangeFilters/index.js